"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _inputGroup = _interopRequireDefault(require("../../../../styles-common/input-group"));

var _const = require("../../const");

var _FilterValue = _interopRequireDefault(require("../FilterValue"));

var _FilterStrings = _interopRequireDefault(require("../FilterStrings"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var StringFilter = function StringFilter(_ref) {
  var filter = _ref.filter,
      _onChange = _ref.onChange;
  var displaySelect = filter.operation === 'by-values';
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_inputGroup["default"], {
    noMargins: displaySelect
  }, _react["default"].createElement(_reactSelect["default"], {
    name: "filter-operation-".concat(filter.id),
    placeholder: "Select an operation",
    value: _const.FILTER_STRING_OPERATIONS.find(function (op) {
      return op.value === filter.operation;
    }),
    options: _const.FILTER_STRING_OPERATIONS,
    onChange: function onChange(_ref2) {
      var value = _ref2.value;
      return _onChange({
        operation: value,
        value: null
      });
    }
  })), !!filter.operation && _react["default"].createElement(_inputGroup["default"], null, displaySelect && _react["default"].createElement(_FilterStrings["default"], {
    filter: filter,
    onChange: function onChange(value) {
      return _onChange({
        value: value
      });
    }
  }), !displaySelect && _react["default"].createElement(_FilterValue["default"], {
    filter: filter,
    onChange: function onChange(value) {
      return _onChange({
        value: value
      });
    }
  })));
};

StringFilter.propTypes = {
  filter: _propTypes["default"].shape({
    column: _propTypes["default"].string.isRequired,
    type: _propTypes["default"].string.isRequired,
    operation: _propTypes["default"].string,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
    config: _propTypes["default"].object.isRequired
  }).isRequired,
  onChange: _propTypes["default"].func.isRequired
};
var _default = StringFilter;
exports["default"] = _default;